import { generateStandardId, generateStandardSecret } from '@rivenai/shared/universal';
import { ApplicationType } from '../db-entries/index.js';
import { adminTenantId } from './tenant.js';
/**
 * The fixed application ID for Admin Console.
 *
 * This built-in application does not belong to any tenant in the OSS version.
 */
export const adminConsoleApplicationId = 'admin-console';
export const demoAppApplicationId = 'demo-app';
export const accountCenterApplicationId = 'account-center';
export const deviceDemoAppApplicationId = 'device-demo-app';
const buildSpaApplicationData = (tenantId, { id, name, description, }) => ({
    tenantId,
    id,
    name,
    secret: 'N/A',
    description,
    type: ApplicationType.SPA,
    oidcClientMetadata: { redirectUris: [], postLogoutRedirectUris: [] },
    customClientMetadata: {},
    protectedAppMetadata: null,
    isThirdParty: false,
    appLevelAccessControlEnabled: false,
    createdAt: 0,
    customData: {},
});
export const buildDemoAppDataForTenant = (tenantId) => buildSpaApplicationData(tenantId, {
    id: demoAppApplicationId,
    name: 'Live Preview',
    description: 'Preview for Sign-in Experience.',
});
export const buildAccountCenterAppDataForTenant = (tenantId) => buildSpaApplicationData(tenantId, {
    id: accountCenterApplicationId,
    name: 'Account Center',
    description: 'Placeholder application for Account Center.',
});
const buildNativeApplicationData = (tenantId, { id, name, description, }) => ({
    tenantId,
    id,
    name,
    secret: 'N/A',
    description,
    type: ApplicationType.Native,
    oidcClientMetadata: { redirectUris: [], postLogoutRedirectUris: [] },
    customClientMetadata: { isDeviceFlow: true },
    protectedAppMetadata: null,
    isThirdParty: false,
    appLevelAccessControlEnabled: false,
    createdAt: 0,
    customData: {},
});
export const buildDeviceDemoAppDataForTenant = (tenantId) => buildNativeApplicationData(tenantId, {
    id: deviceDemoAppApplicationId,
    name: 'Device Flow Preview',
    description: 'Preview for Device Authorization Flow.',
});
export const isBuiltInApplicationId = (applicationId) => applicationId === demoAppApplicationId ||
    applicationId === accountCenterApplicationId ||
    applicationId === deviceDemoAppApplicationId;
export const isBuiltInClientId = isBuiltInApplicationId;
export const buildBuiltInApplicationDataForTenant = (tenantId, applicationId) => {
    if (applicationId === demoAppApplicationId) {
        return buildDemoAppDataForTenant(tenantId);
    }
    if (applicationId === deviceDemoAppApplicationId) {
        return buildDeviceDemoAppDataForTenant(tenantId);
    }
    return buildAccountCenterAppDataForTenant(tenantId);
};
export const createDefaultAdminConsoleApplication = () => Object.freeze({
    tenantId: adminTenantId,
    id: adminConsoleApplicationId,
    name: 'Admin Console',
    secret: generateStandardSecret(),
    description: 'Riven Auth Admin Console.',
    type: ApplicationType.SPA,
    oidcClientMetadata: { redirectUris: [], postLogoutRedirectUris: [] },
});
export const createTenantMachineToMachineApplication = (tenantId) => Object.freeze({
    tenantId: adminTenantId,
    id: generateStandardId(),
    name: 'Cloud Service',
    description: `Machine to machine application for tenant ${tenantId}`,
    secret: generateStandardSecret(),
    type: ApplicationType.MachineToMachine,
    oidcClientMetadata: {
        redirectUris: [],
        postLogoutRedirectUris: [],
    },
    customClientMetadata: {
        tenantId,
    },
});
/** Create an entry to assign a role to an application in the admin tenant. */
export const createAdminTenantApplicationRole = (applicationId, roleId) => Object.freeze({
    id: generateStandardId(),
    tenantId: adminTenantId,
    applicationId,
    roleId,
});
